module.exports = __webpack_public_path__ + "static/media/mini.504d2949.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200仓栅车/mini.png
// module id = 714
// module chunks = 0